<template>
    <div class="document-file-operation">
        <div class="document-file-left">
            <div class="document-file-input">
                <el-input v-model="fileName" placeholder="请输入文件名称"></el-input>
            </div>
            <div class="document-file-button">
                <el-button type="primary" @click="$emit('query', fileName)">查询</el-button>
            </div>
        </div>
        <div class="document-file-right">
            <el-upload action="" :show-file-list="false" accept="*/*" :http-request="upload">
                <div class="document-file-upload">
                    <i class="el-icon-upload"></i>上传
                </div>
            </el-upload>
            <!-- <div class="document-file-modify">
                <i class="el-icon-document"></i>修改
            </div>
            <div class="document-file-delete">
                <i class="el-icon-delete"></i>删除
            </div> -->
        </div>
    </div>
</template>

<script>
    import {
        UploadFile
    } from '@/api/equipment'
    export default {
        props: ['folderName', 'files'],
        data() {
            return {
                fileName: ''
            }
        },
        computed: {
            projectId: function () {
                return this.$store.getters.projectId;
            },
            fileNames: function () {
                return this.files.map(item => {
                    return item.name + '.' + item.type
                })
            }
        },
        methods: {
            upload(option) {
                let result = this.validateFileName(option.file.name)
                if (!result) return
                const isJPG = option.file.type === "image/jpeg";
                const isJPEG = option.file.type === "image/jpeg";
                const isPNG = option.file.type === "image/png";
                // const isHTML = option.file.type === "text/html";
                // const isGIF = option.file.type === "image/gif";
                // const isSVG = option.file.type === "image/svg+xml";
                const isDOC = option.file.type === "application/msword";
                const isDOCX = option.file.type ===
                    "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
                const isPDF = option.file.type === "application/pdf";
                if (!isJPG && !isJPEG && !isPNG && !isDOC && !isDOCX && !isPDF) {
                    this.$message.error("上传文件格式只能是 JPG、JPEG、PNG、DOC、DOCX、PDF 格式!");
                    return false;
                } else if (this.fileNames.includes(option.file.name)) {
                    this.$message({
                        type: 'error',
                        message: '文件已存在'
                    });
                } else {
                    let fname = this.folderName ? this.folderName : '默认文件夹'
                    UploadFile(
                        this.projectId,
                        fname,
                        option.file,
                    ).then((res) => {
                        if (res.status == 200) {
                            this.$parent.getAll(fname).then(() => {
                                this.$message({
                                    type: 'success',
                                    message: '上传成功'
                                });
                            })
                        } else {
                            this.$message({
                                type: 'error',
                                message: '上传失败'
                            })
                        }
                    })
                }
            },
            validateFileName(value) {
                let fileName = value.split('.').slice(0, value.split('.').length - 1).join('.')
                var reg = new RegExp('[\\\\/:*?\"<>| .]');
                if (reg.test(fileName)) {
                    this.$message({
                        duration: 5000,
                        message: "上传的文件名不能包含 \/:*?\"<>|. 和空格,请修改后重新上传!",
                        type: 'error'
                    });
                    return false
                }
                return true
            }
        }
    }
</script>


<style lang="less" scoped>
    .document-file-operation {
        height: 100%;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;

        padding-left: 24rem;
        padding-right: 24rem;

        .document-file-left {
            display: flex;
            // visibility: hidden;

            .document-file-input {
                .w(260)
            }

            .document-file-button {
                margin-left: 24rem;
            }
        }

        .document-file-right {
            display: flex;
            justify-content: flex-end;
            .w(227);
            // visibility: hidden;

            font-size: 18rem;
            font-weight: 400;
            color: #333333;

            i:after {
                content: '';
                margin-left: 7rem;
            }

            .document-file-upload {
                cursor: pointer;
                color: #333333 !important;
            }
        }

    }
</style>